<template>
  <div class="header">
    <div class="headerLeft">
      <el-image class="image" :src="loginPng" fit="fill" style="pointer-events: none;cursor: default;"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //- 平台logo
    loginPng: {
      type: String,
      default: ''
    },
    //- 初始平台选中值
    initial: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {

    };
  },
  methods: {

  },
  mounted () {
    this.value = this.initial;//- 初始值赋值
  }
};
</script>

<style scoped lang="scss">
.header {
  width: 96%;
  padding: 0 2%;
  background-color: white;
  height: 50px;
  // line-height: 50px;
  position: fixed;
  left: 0;
  top: 0;
  .headerLeft {
    display: inline-block;
    .image {
      width: 80px;
      height: 40px;
      margin-top: 5px;
    }
  }
  .headerRight {
    float: right;
    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
      margin-top: 8px;
    }
  }
}
</style>
